services.service('UserControl', [
    'UserService', '$state', 'constants',
    /**
     * @name UserControl
     * @class
     */
    function (UserService, $state, Const) {

        this.getState = function () {
            var user = UserService.get();
            if (!user) return;

            if (!user.tnc && Const['tncPopup']) {
                return 'tnc'
            }

            if (!user.classification.length && user.liveAccountExists) {
                return 'signupQuestionnaire';
            }

            // follow cmtrading registration flow
            if (Const['splitPersonalDetails']) {
                if (!user.taxCountry.length) {
                    return 'signupPersonalProfile'
                }
                if (user.isRegulated() && !user.classification.length) {
                    return 'signupQuestionnaire';
                }
            }

            if (!user.activeTradingAccount) {
                switch (user.registrationState) {
                    case Const.userState.initial:
                        return 'signupPersonalProfile';
                    case Const.userState.personal:
                    case Const.userState.questionnaire:
                        return 'signupQuestionnaire';
                }
            }
        };

        return this;
    }
]);
